import React, { useState } from "react";
import { InputGroup } from "reactstrap";
import FinalTableSpy from "../FinalTable/FinalTableSpy";
import SimpleDatePickerField from "../Form/SimpleDatePickerFieldV2/SimpleDatePickerField";
import "./DateFilter.scss";

interface DateFilterProps {
  fieldLabel: string;
  filterKey: string;
  name: string;
  value?: Date | string | null;
}

const DateFilter: React.FC<DateFilterProps> = ({ fieldLabel, filterKey, name, value = null }) => {
  const [date, setDate] = useState<string | Date | null>(value);

  return (
    <FinalTableSpy>
      {props => (
        <div className="date-filter">
          <label className="date-filter__label">{fieldLabel}</label>
          <InputGroup className="input-group">
            <SimpleDatePickerField
              name={name}
              input={{
                value: date,
                onChange: (val: string | null) => {
                  setDate(val);
                  props.update({ page: 1, query: { [filterKey]: val } });
                },
              }}
            />
          </InputGroup>
        </div>
      )}
    </FinalTableSpy>
  );
};

export default DateFilter;
